const RoundedCard = {
  $: 'Box',
  props: {
    px: 10,
    py: 8,
    borderRadius: '14px',
    boxShadow:
      'rgb(0 0 0 / 10%) 0px 0px 12px 0px, rgb(0 0 0 / 10%) 0px 0px 0px 0px, rgb(0 0 0 / 10%) 0px 0px 0px 0px',
  },
  children: ({ content }) => ({
    $: 'Stack',
    props: {
      direction: 'column',
      spacing: 0,
    },
    children: content,
  }),
};

export default RoundedCard;
